import React from 'react';
import PropTypes from 'prop-types';

function LeftStickBackground({ color, opacity }) {
  return (
    <>
      <path
        d="M354.078 309.927C354.078 343.998 326.459 371.617 292.388 371.617C258.318 371.617 230.698 343.998 230.698 309.927C230.698 300.667 232.739 291.883 236.395 284L267.943 253.27C275.439 250.031 283.704 248.237 292.388 248.237C326.459 248.237 354.078 275.857 354.078 309.927Z"
        fill={color}
        fillOpacity={opacity}
      />

      <path
        d="M334.745 304.458C334.745 327.078 316.407 345.415 293.787 345.415C271.168 345.415 252.831 327.078 252.831 304.458C252.831 281.838 271.168 263.5 293.787 263.5C316.407 263.5 334.745 281.838 334.745 304.458Z"
        fill="#020202"
      />
    </>
  );
}

LeftStickBackground.propTypes = {
  color: PropTypes.string,
  opacity: PropTypes.number,
};

LeftStickBackground.defaultProps = {
  color: '#32353A',
  opacity: 1,
};

export default LeftStickBackground;
